<dashboardnav>

  <cradua-companyfunction
  [companies]="companies$ | async"
  [companyfunctions]="companyfunctions$ | async"

  (changeEmit)="onSubmitCompanyFunction($event)"
  (deleteEvent)="onDeleteCompanyFunction($event)"
  *ngIf="
  !(isLoadingCompany$ | async ) &&
  !(isLoadingCompanyFunction$ | async )
  "
  >
</cradua-companyfunction>

  <mrsoftapps-epims-reference-spinner
  *ngIf="
  (isLoadingCompany$ | async ) ||
  (isLoadingCompanyFunction$ | async )
  "
>
  </mrsoftapps-epims-reference-spinner>
</dashboardnav>
